import { BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TreeItemGroupTransition } from "@mui/x-tree-view-pro";
import { includeIf, hasNotProp } from "@sinch/utils/object";

export const RateBuilderTreeGroupTransition = styled(TreeItemGroupTransition, {
  shouldForwardProp: hasNotProp(["wrapped"]),
})<BoxProps & { wrapped?: boolean }>(({ wrapped }) => ({
  //paddingTop: theme.spacing(1),
  "&>.MuiCollapse-wrapper>.MuiCollapse-wrapperInner": {
    display: "flex",
    flexDirection: "column",
    //gap: 1,
    position: "relative",
    ...includeIf(
      !!wrapped,
      {
        paddingLeft: "0px",
        //marginLeft: theme.spacing(-1),
      },
      {
        paddingLeft: "var(--level-identation-offset)",
      }
    ),
  },
}));
